<template>
    <div id="editBrand">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
            <h5 class="modal-title" id="exampleModalLabel">Edit Brand</h5><br>
            <p style="color:red;text-align:center">{{ errorMessage }}</p>
                  <p v-if="errors.length">
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p> 

            <button type="button" class="close" data-dismiss="modal" id="editbrandpopupclose" @click="$emit('close')"  aria-label="Close">
              <i class="material-icons">close</i>
            </button>
          </div>
          <form action="#" @keyup.enter="editBrand()">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="sub-title">Brand Information</h6>
                  <div class="form-group">
                    <input type="text" class="form-control" name="brand_name" ref="brand_name"  v-model="brandDetails.brand_name" placeholder="Brand Name"/>
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" name="site_url" ref="site_url" v-model="brandDetails.site_url" placeholder="Site URL" />
                  </div>
                  <div class="form-group">
                    <input type="email" class="form-control" name="email" ref="email" v-model="brandDetails.email" placeholder="Email" />
                    <p class="sub-title" style="color:blue;">This is where the invoice will be sent.</p>
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" name="address" ref="address" v-model="brandDetails.address"  placeholder="Complete Address" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" name="contactno" ref="contactno" v-model="brandDetails.contact_no" placeholder="Contact Number" />
                    <input type="hidden" class="form-control" name="uid" v-model="brandDetails.uid" placeholder="Brand Id" />
                  </div>
                  <div class="form-group">
                    <!-- <input type="file" class="form-control" placeholder="File" /> -->
                    <input class="form-control" type="file" name="brand_logo" ref="fileedit" id="fileedit" v-on:change="handleFileUploadedit()" />
                    <img style="max-height:100px;" v-bind:src=" brandDetails.brand_logo ">
                  </div>
                </div>
                <div class="col-md-6">
                  <h6 class="sub-title">Contact Information</h6>
                  <div class="form-group">
                    <!-- <input type="text" class="form-control" ref="contacttitle" name="contacttitle" v-model="brandDetails.contact_title" placeholder="Contact Title" /> -->
                  </div>
                   <div class="form-group d-flex">
                    <select class="form-control select" ref="nameprefix" id="nameprefix" name="nameprefix" v-model="brandDetails.contact_name_prefix" @change="changePrefix($event)">
                      <!-- <option value="" selected>Select Title</option>-->
                      <option value="Mr">Mr. </option>
                      <option value="Mrs">Mrs. </option>
                      <option value="Ms">Ms. </option>
                    </select>
                 
                    <input type="text" class="form-control" ref="contactfirstname" name="contactfirstname" v-model="brandDetails.contact_first_name" placeholder="Contact First name" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" ref="contactlastname" name="contactlastname" v-model="brandDetails.contact_last_name" placeholder="Contact Last name" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" ref="contactemail" name="contactemail" v-model="brandDetails.contact_email" placeholder="Contact Email" />
                  </div>
                </div>
              </div>
              
              <div><hr></div>
            </div>
            <div class="modal-footer">
              <!-- <button type="button" class="btn btn-primary">Add</button> -->
              <input type="button" class="btn btn-primary" value="Update" v-on:click="editBrand()"/>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'EditBrandModal',
  props: ['brandDetails'],
  components: {
    Loading
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      brandsList: [],
      brands: [],
      errors: [],
      brandDetails: {
        brand_name: '',
        site_url: '',
        email: '',
        contact_no: '',
        uid: '',
        address: '',
        contact_title: '',
        contact_first_name: '',
        contact_last_name: '',
        contact_email: '',
        brand_logo: '',
        contact_name_prefix: ''

      },
      fileadd: '',
      fileedit: '',
      brandstatus: ''
    }
  },
  methods: {
    editBrand () {
      var fuData = document.getElementById('fileedit')
      var FileUploadPath = fuData.value
      var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase()
      var contactemail = this.brandDetails.contact_email
      var atposition = contactemail.indexOf('@')
      var dotposition = contactemail.lastIndexOf('.')
      var email = this.brandDetails.email
      var atpositionEmail = email.indexOf('@')
      var dotpositionEmail = email.lastIndexOf('.')
      var contactNo = this.brandDetails.contact_no
      this.errors = []
      if (this.brandDetails.brand_name === '') {
        this.errors.push('Brandname is Required')
        this.$refs.brand_name.focus()
      } else if (this.brandDetails.site_url === '') {
        this.errors.push('Siteurl is Required')
        this.$refs.site_url.focus()
      } else if (!this.validUrl.isUri(this.brandDetails.site_url)){  
        this.errors.push('Not a URL')
        this.$refs.site_url.focus()
      } else if (this.brandDetails.email === '') {
        this.errors.push('Email is Required')
        this.$refs.email.focus()
      } else if (!this.emailValidator.validate(email)) {
        this.errors.push('Please enter a valid e-mail address')
        this.$refs.email.focus()
      } else if (this.brandDetails.address === '') {
        this.errors.push('Address is Required')
        this.$refs.address.focus()
      } else if (this.brandDetails.contact_no === '') {
        this.errors.push('Contact no is Required')
        this.$refs.contact_no.focus()
      } else if (isNaN(contactNo) || contactNo.indexOf(" ")!=-1) {
        this.errors.push('Enter numeric value')
        this.$refs.contact_no.focus()
      } else if (contactNo.length !== 10) {
        this.errors.push('Enter 10 Numbers Only')
        this.$refs.contact_no.focus()
      } else if (this.fileedit !== '' && !this.checkExtension(ext)) {
             this.errors.push('Only jpeg , png , gif Allowed')
      } else if (this.brandDetails.contact_name_prefix === '') {
        this.errors.push('Contact Name Prefix is Required')
        this.$refs.contact_name_prefix.focus()
      } else if (this.brandDetails.contact_first_name === '') {
        this.errors.push('Contact First Name is Required')
        this.$refs.contact_first_name.focus()
      } else if (this.brandDetails.contact_last_name === '') {
        this.errors.push('Contact Last Name is Required')
        this.$refs.contact_last_name.focus()
      } else if (contactemail === '') {
        this.errors.push('Contatct Email is Required')
        this.$refs.contactemail.focus()
      } else if (!this.emailValidator.validate(contactemail)) {
        this.errors.push('Please enter a valid Contatct e-mail address')
        this.$refs.contactemail.focus()
      } else { 
        this.isLoading = true
        var jwttoken = localStorage.getItem('jwt')
        let formData = new FormData()
        formData.append('email', this.brandDetails.email)
        formData.append('brand_name', this.brandDetails.brand_name)
        formData.append('site_url', this.brandDetails.site_url)
        formData.append('contact_no', this.brandDetails.contact_no)
        formData.append('address', this.brandDetails.address)
        formData.append('uid', this.brandDetails.uid)
        formData.append('brand_logo', this.fileedit)
        formData.append('contact_title', this.brandDetails.contact_title)
        formData.append('contact_name_prefix', this.brandDetails.contact_name_prefix)
        formData.append('contact_first_name', this.brandDetails.contact_first_name)
        formData.append('contact_last_name', this.brandDetails.contact_last_name)
        formData.append('contact_email', this.brandDetails.contact_email)
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editBrand',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'x-access-token': jwttoken
            }
          }
        ).then(response => {
          this.isLoading = false
          this.$eventBus.$emit('listBrand', 'Brand is updated successfully');
          this.$emit('close')
        })
          .catch((error) => {
            this.$eventBus.$emit('listBrand', '','Brand could not be updated');
            this.$emit('close')
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      }
    },
    handleFileUploadedit () {
      this.fileedit = this.$refs.fileedit.files[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditBrandModal.vue